import { useTranslation } from "react-i18next";
import MillimetreSquared from "../../../../components/Math/Units/Metric/MillimetreSquared";
import { NumberFormatText } from "../../../../components/NumberFormatText";
import { RowBody } from "../../../../components/RowValue/RowBody";

function QuerschnittStahltragglied({ querschnitt }) {
  const { t } = useTranslation("translation");

  return (
    <RowBody
      titleValue={<p>{t("inner.fatigue.crossSection")}</p>}
      indicesValue={
        <span>
          A<sub>s</sub>
        </span>
      }
      inputValue={
        <span className="input">
          <NumberFormatText value={querschnitt} decimalScale={0} />
        </span>
      }
      unitValue={<MillimetreSquared />}
    />
  );
}

export default QuerschnittStahltragglied;
